__webpack_require__.p = "https://pa-cosmos-ui.api.prismaaccess.com/pra-config-ui/gov/";